/* eslint-disable import/prefer-default-export */
export enum UserStatus {
  pending = 'pending',
  expired = 'expired',
  enabled = 'enabled',
  disabled = 'disabled',
}
